<template>
  <button
    type="button"
    :aria-pressed="value ? 'true' : 'false'"
    :class="['t-button-toggle', baseClass, {'t-checked': value}]"
    @click="toggle()"
    v-on:keyup.shift.arrow-left.stop="toggle(false)"
    v-on:keyup.shift.arrow-right.stop="toggle(true)"
  >
    <span class="t-label">
      <span :class="['t-icon-spot', iconClass]" aria-hidden="true"></span>
      <span class="t-label-text"><slot></slot></span>
    </span>
  </button>
</template>

<script>
import BaseMixin from './BaseMixin.vue'

export default {
  name: 'ButtonToggle',

  mixins: [BaseMixin],

  inheritAttrs: false,

  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    toggle(v = !this.value) {
      this.$emit('input', v)
    },
  },
}
</script>
